import { render } from "./ListProdutosFarmacias.vue?vue&type=template&id=0d46213a&scoped=true"
import script from "./ListProdutosFarmacias.vue?vue&type=script&lang=js"
export * from "./ListProdutosFarmacias.vue?vue&type=script&lang=js"

import "./ListProdutosFarmacias.vue?vue&type=style&index=0&id=0d46213a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d46213a"]])

export default __exports__